import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import closeAlliance from './closeAlliance';

export default (id, callback) => (dispatch) => {
    const dataAlert = {
        messages: [
            i18next.t(
                'When you close the request you will no longer be able to revert the changes',
            ),
        ],
        onSuccess: () => dispatch(closeAlliance(id, callback)),
        textToValidate: i18next.t('Delete').toUpperCase(),
        title: i18next.t('Confirmation'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };

    dispatch(alerts.actions.show(dataAlert));
};
